/**
 * GuestSignupContent — web port of RN Dashboard's `renderBottomDrawer()`.
 * Shown when a guest taps the avatar ring or the dashboard CTA banner.
 * Pulls multilingual copy from /content/guest with a hardcoded fallback.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGuestUX } from '@wg/hooks/guest';
import { useAuthContext } from '@wg/hooks/auth';
import { useUserContext } from '../../context/UserContext';
import { useLanguage } from '../../hooks/useLanguage';
import { useDrawer } from '../../context/DrawerContext';
import { contentApi } from '../../client';
import './GuestSignupContent.css';

const GuestSignupContent: React.FC = () => {
  const navigate = useNavigate();
  const { isGuest, sessionInfo } = useAuthContext();
  const { user } = useUserContext();
  const { selectedLanguage } = useLanguage();
  const { closeDrawer } = useDrawer();

  const { guestContent } = useGuestUX({
    isGuest,
    firstName: sessionInfo?.firstName,
    userFirstName: user?.firstName,
    language: selectedLanguage,
    contentApi,
  });

  const go = (path: '/register' | '/signin') => {
    closeDrawer();
    navigate(path);
  };

  return (
    <div className="wg-guest-signup">
      <ul className="wg-guest-signup__bullets">
        {guestContent.drawer.features.map((f, i) => (
          <li key={i} className="wg-guest-signup__bullet">
            <span className="wg-guest-signup__bullet-icon" aria-hidden>
              {f.icon}
            </span>
            <span className="wg-guest-signup__bullet-text">{f.text}</span>
          </li>
        ))}
      </ul>

      <div className="wg-guest-signup__divider" aria-hidden />

      <p className="wg-guest-signup__quick">
        {guestContent.drawer.quickSignupText}
      </p>

      <button
        type="button"
        className="wg-guest-signup__cta-primary"
        onClick={() => go('/register')}
      >
        {guestContent.drawer.createAccountCta}
      </button>

      <button
        type="button"
        className="wg-guest-signup__cta-secondary"
        onClick={() => go('/signin')}
      >
        {guestContent.drawer.signInCta}
      </button>
    </div>
  );
};

export default GuestSignupContent;
